<template>
  <CustomForm header="Оформить полис онлайн">
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="row g-1 g-md-3">


          <div class="col-12 col-md-3 vd-pick">
            <label for="lang-select" class="p-r-16">Дата начала договора</label>
            <VueDatePicker class="vd-picker__input" v-model="dateBegin" :format="'D.MM.YYYY'" :element.sync="dateBegin"
                           type="date" :value="selectedDate" :min-date="minDate" :color="color"/>
          </div>

          <div class="col-12 col-md-3">
            <CustomSelect label="Период страхования" v-model="period" :options="periods"
                          :element.sync="period" :disabled="disabled.period"></CustomSelect>
          </div>
          <div class="col-12 col-md-6 ">
            <CustomSelect label="Виды спорта" v-model="sportType" :options="sportTypes" :element.sync="sportType"
                          :multiple="true" :disabled="disabled.sportType">
              <option value="" disabled selected>Текст</option>
            </CustomSelect>
          </div>
          <div class="col-12 col-md-6">
            <CustomSelect label="Страховая сумма" v-model="issuanceSumm" :options="issuanceSumms"
                          :element.sync="issuanceSumm" :disabled="disabled.issuanceSumm"></CustomSelect>
          </div>
          <div class="col-12 col-md-6">
            <CustomSelect label="Период действия защиты" v-model="issuanceType" :options="issuanceTypes"
                          :element.sync="issuanceType" :disabled="disabled.issuanceType"></CustomSelect>
          </div>
          <div class="col-12 col-md-6">
            <CustomInput label="Кол-во застрахованных взрослых" v-model="adultCount" :element.sync="adultCount"
                         :number-buttons="true" type="number"/>
          </div>
          <div class="col-12 col-md-6">
            <CustomInput label="Кол-во застрахованных детей" v-model="childCount" :element.sync="childCount"
                         :number-buttons="true" type="number"/>
          </div>
        </div>
      </div>
      <div class="col-12 block_price" v-if="!finalLoad">
        <div class="price">
          <p v-if="!load" class="price_total">Сумма: <strong>{{ premiumSum }} руб.</strong></p>
        </div>
        <div class="load" v-if="load">
          <stretch size="60px"></stretch>
        </div>
        <div class="bt">
          <button class="btn btn-success btn-min" @click="calculate()" :class="{ 'disabled': !isValidForm || load }"
                  :disabled="!isValidForm ||  load">
            Рассчитать
          </button>
        </div>

        <div class="next">
          <button class="btn btn-success button col-12" :class="{ 'disabled': !isValidForm }" :disabled="!isValidForm"
                  @click="next()" v-if="parseInt(premiumSum, 10)">
            Продолжить оформление
          </button>

        </div>
      </div>
      <loading-block v-if="finalLoad"/>
    </div>
  </CustomForm>
</template>
<script>
import {Stretch} from 'vue-loading-spinner'
import CustomForm from './misc/Form.vue'
import CustomSelect from './misc/Select.vue'
import CustomInput from './misc/Input.vue'
import LoadingBlock from '@/components/misc/LoadingBlock';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';

export default {
  name: 'StepOne',
  components: {
    LoadingBlock,
    VueDatePicker,
    CustomForm,
    CustomSelect,
    CustomInput,
    Stretch,
  },
  data() {
    return {
      disabled: {
        period: false,
        issuanceType: false,
        sportType: false,
        issuanceSumm: false,
      },
      periods: [],
      period: null,
      sportTypes: [],
      sportType: null,
      issuanceSumms: [],
      issuanceSumm: null,
      issuanceTypes: [],
      issuanceType: null,
      adultCount: '0',
      childCount: '0',
      premiumSum: '0',
      load: false,
      finalLoad: false,
      selectedDate: null,
      dateBegin: new Date(new Date().setDate(new Date().getDate() + 0)).toISOString().slice(0, 10),
      minDate: new Date(new Date().setDate(new Date().getDate() + 0)).toISOString().slice(0, 10),
      color: '#49b165'
    }
  },
  computed: {
    isValidForm() {
      if (!(this.period && this.sportType && this.issuanceType && this.issuanceSumm && this.dateBegin)) {
        return false;
      }
      if (!(this.adultCount > 0 || this.childCount > 0)) {
        return false;
      }
      if (
          !Object.keys(this.period).length ||
          !Object.keys(this.sportType).length ||
          this.issuanceSumm === null ||
          !Object.keys(this.issuanceType).length ||
          this.dateBegin === null
      ) {
        return false;
      }
      return true;
    }
  },
  methods: {
    sport() {
      // Ваш код JavaScript здесь

      // Вызов функции отправки уведомления в телеграм-канал
      this.sendTelegramNotification();
    },

    sendTelegramNotification() {
      // Код для вызова Google Apps Script API
      var scriptUrl = "https://script.google.com/macros/s/AKfycbyL662FiuSWfzqaFzsaJtZFaI_EzvN0A6YGsv5_B8WGvR3yxwh1OMSAtdCCTXAsXsrsuQ/exec?buttonClicked=true";

      // Вызов API Google Apps Script
      fetch(scriptUrl)
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error(error);
          });
    },
    calculate() {
      this.load = true;
      this.$parent.store.externalData.params.forEach((el, key) => {
        if (el.attrIsn === '949111') {
          this.$parent.store.externalData.params[key].value = this.issuanceSumm;
          this.$parent.store.externalData.params[key].val = this.issuanceSumm;
        }
        if (el.attrIsn === '949031') {
          this.$parent.store.externalData.params[key].val = this.period.isn;
          this.$parent.store.externalData.params[key].value = this.period.value;
        }
        if (el.attrIsn === '949041') {
          this.$parent.store.externalData.params[key].val = this.issuanceType.isn;
          this.$parent.store.externalData.params[key].value = this.issuanceType.value;
        }
        if (el.attrIsn === '1055131') {
          const sportTypes = [];
          this.sportType.forEach((el) => {
            sportTypes.push(el.isn);
          })
          this.$parent.store.externalData.params[key].value = sportTypes;
          //this.$parent.store.externalData.params[key].value = this.sportType.isn;
          //this.$parent.store.externalData.params[key].val = this.sportType.value;
        }
        if (el.attrIsn === '959211') {
          this.$parent.store.externalData.params[key].value = this.adultCount;
          this.$parent.store.externalData.params[key].val = this.adultCount;
        }
        if (el.attrIsn === '959201') {
          this.$parent.store.externalData.params[key].value = this.childCount;
          this.$parent.store.externalData.params[key].val = this.childCount;
        }
      });
      this.$parent.peopleCount = parseInt(this.adultCount,10) + parseInt(this.childCount,10);
      const params = [];
      const neededIsns = ['949111', '949031', '949041', '1055131', '959211', '959201'];
      this.$parent.store.externalData.params.forEach((el, key) => {
        if (neededIsns.includes(el.attrIsn)) {
          params.push({
            attrIsn: this.$parent.store.externalData.params[key].attrIsn,
            val: this.$parent.store.externalData.params[key].val,
            value: this.$parent.store.externalData.params[key].value
          });
        }
      });
      this.$api.save(this.$parent.store.externalData.isn, params, this.$parent.token)
          .then(() => {
            this.$api.calculate(this.$parent.store.externalData.isn, this.$parent.token)
                .then((data) => {
                  this.premiumSum = data.data.premiumSum || 0;
                  this.load = false;
                })
          })

    },

    resetValues() {
      if (this.sportType === '' || this.sportType === null) {
        this.sportType = null; // сбросить значение inputValue
        return 0; // сбросить значение premiumSum
      } else {
        // выполнить другие действия, если поле ввода не пустое или не равно null
        return // ваш код для вычисления premiumSum
      }
    },
    next() {
      this.finalLoad = true;
      this.$parent.store.requestModel.firstForm.sum = this.issuanceSumm;
      this.$parent.store.requestModel.firstForm.period = this.period;
      this.$parent.store.requestModel.firstForm.actionPeriod = this.issuanceType;
      this.$parent.store.requestModel.firstForm.sportType = this.sportType;
      this.$parent.store.requestModel.firstForm.countAdult = this.adultCount;
      this.$parent.store.requestModel.firstForm.countChildren = this.childCount;

      this.calculate();
      this.$parent.dateBeginAgreement = this.dateBegin;
      this.$parent.store.currentRoute = 'step2';
    },
    selectorsInit() {
      this.periods = this.$parent.store.dictionaries.issuancePeriods;
      this.sportTypes = this.$parent.store.dictionaries.sportTypes;
      this.issuanceSumms = this.$parent.store.dictionaries.issuanceSumms;
      this.issuanceTypes = this.$parent.store.dictionaries.issuanceTypes;

      if (this.periods.length === 1) {
        this.period = this.periods[0];
        this.disabled.period = true;
      }
      if (this.issuanceTypes.length === 1) {
        this.issuanceType = this.issuanceTypes[0];
        this.disabled.issuanceType = true;
      }
      if (this.sportTypes.length === 1) {
        this.sportType = this.sportTypes[0];
        this.disabled.sportType = true;
      }
      if (this.issuanceSumms.length === 1) {
        this.issuanceSumm = this.issuanceSumms[0];
        this.disabled.issuanceSumm = true;
      }
    },

  },
  mounted() {
    this.selectorsInit();
  },
  watch: {
    // eslint-disable-next-line
    '$parent.store.dictionaries.issuancePeriods'() {
      this.selectorsInit();
    },
    // eslint-disable-next-line
    '$parent.store.dictionaries.sportTypes'() {
      this.selectorsInit();
    },
    // eslint-disable-next-line
    '$parent.store.dictionaries.issuanceSumms'() {
      this.selectorsInit();
    },
    // eslint-disable-next-line
    '$parent.store.dictionaries.issuanceTypes'() {
      this.selectorsInit();
    },
    dateBegin() {
      console.log(this.dateBegin)
    },
    issuanceSumm(val, oldVal) {
      if (this.premiumSum && val !== oldVal) {
        this.premiumSum = 0;
      }
    },
    childCount(val, oldVal) {
      if (this.premiumSum && val !== oldVal) {
        this.premiumSum = 0;
      }
    },
    adultCount(val, oldVal) {
      if (this.premiumSum && val !== oldVal) {
        this.premiumSum = 0;
      }
    },
    period: {
      handler: function (val, oldVal) {
        if (oldVal !== null && this.premiumSum && val.isn !== oldVal.isn) {
          this.premiumSum = 0;
        }
      },
      deep: true,
    },
    issuanceType: {
      handler: function (val, oldVal) {
        if (oldVal !== null && this.premiumSum && val.isn !== oldVal.isn) {
          this.premiumSum = 0;
        }
      },
      deep: true,
    },
    sportType: {
      handler: function (val, oldVal) {
        if (oldVal !== null && this.premiumSum && val.length !== oldVal.length) {
          this.premiumSum = 0;
        }
      },
      deep: true,
    },
  }
}
</script>
<style scoped>

label.p-r-16 {
  margin-bottom: 0px;
}

.vd-pick {
  margin-top: 13px;
}

label.p-r-16 {
  width: 100%;
  font-weight: 600;
  color: #565656;
  font-size: .85rem;
}

.vd-picker__input {
  background: white;
  border-radius: 4px;
  border: var(--vs-border-width) var(--vs-border-style) var(--vs-border-color);
}

.price {
  margin: 0px;
  max-width: 180px;
}

.price .bt {
  text-align: center;
}

.price button {
  font-size: 0.85rem;
  font-weight: 600;
}

.price .p {
  font-size: 18px;
  font-weight: 800;
}

.btn-min {
  font-size: 0.85rem;
  font-weight: 600;
}

.next .button {
  float: right;
  font-size: 0.85rem;
  font-weight: 600;
}

.load {
  text-align: center;
  margin: 18px 10px;
}

.block_price {
  display: flex;
  justify-content: left;
  align-items: center;
  grid-gap: 20px;
  padding-top: 20px;
}

p.price_total {
  margin-bottom: 0rem;
}

@media (max-width: 768px) {
  .block_price {
    display: grid;
    justify-content: center;
  }
}
</style>
